import {
  getCurrentPage,
  getCurrentPageBlockList,
  getBlockList,
  isEndEnabled,
  isEndEmpty,
  getRedirectUrl,
  getLastPageNumber,
  isBlockNextOrSubmitButton,
  getFirstInvalidFormName,
  isAllPageAnswersValid,
  getCurrentSectionHeaderBackgroundImageUrl,
  getCurrentSectionHeaderBackgroundCoords,
  getCurrentSectionHeaderLogoImageUrl,
  getCurrentSectionHeaderLogoImageAlign,
  getCurrentSectionHeaderLogoWithTextAlign,
  getCurrentSectionName,
  getInvalidFormNameToScroll,
  isSurveyLastPage,
  getCurrentSectionHeaderHeight,
  getCurrentSectionHeaderBackgroundColor,
  isCurrentSectionHeaderFullWidth,
  getCurrentSectionHeaderPageBoxType,
  isCurrentSectionHeaderPlaceholder,
  getCurrentSectionHeaderBackgroundImageSize,
  getNextPageNumber,
  getPendingRedirectIdByNextPageNumber,
  getPendingRedirectToBlockId,
  getVisitedQuestions,
  isQuestionLogicValid,
  getQuestionLogicRedirectBlockId,
  isSurveyFullWidth,
  isLandingCurrentSection,
  getSurveySectionLastPageNumber,
  hasSurveyQuestionsSectionOnlyOnePage,
  isCurrentSectionHeaderContentEnabled,
  getCurrentSectionHeaderLogoImageLinkUrl,
  getCurrentSectionHeaderLogoImageSizePreset,
  getCurrentSectionHeaderLogoImageSize,
  getCurrentSectionHeaderLayout,
  getCurrentSectionHeaderTextContent,
  getCurrentSectionHeaderClientUuid,
  getCurrentSectionHeaderEnabled,
  isSurveyFirstPage,
  getDisplayPage,
  getLatestVisitedPageNumber,
  getVisitedPages,
  getVisitedPagesLength,
  isSurveyBackButtonEnabled,
} from 'taker/reducers';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import surveyTakerReducer from '../taker/reducers/surveyTakerReducer';
import responseReducer from '../taker/reducers/responseReducer';

export {
  getBlockList,
  getCurrentPage,
  getCurrentPageBlockList,
  isEndEnabled,
  isEndEmpty,
  getRedirectUrl,
  getLastPageNumber,
  isBlockNextOrSubmitButton,
  getFirstInvalidFormName,
  isAllPageAnswersValid,
  getInvalidFormNameToScroll,
  getCurrentSectionHeaderBackgroundImageUrl,
  getCurrentSectionHeaderBackgroundCoords,
  getCurrentSectionHeaderLogoImageUrl,
  getCurrentSectionHeaderLogoImageAlign,
  getCurrentSectionHeaderLogoWithTextAlign,
  getCurrentSectionName,
  getCurrentSectionHeaderEnabled,
  getVisitedQuestions,
  isSurveyLastPage,
  getCurrentSectionHeaderHeight,
  getCurrentSectionHeaderBackgroundColor,
  isCurrentSectionHeaderFullWidth,
  getCurrentSectionHeaderPageBoxType,
  isCurrentSectionHeaderPlaceholder,
  getCurrentSectionHeaderBackgroundImageSize,
  getNextPageNumber,
  getPendingRedirectIdByNextPageNumber,
  getPendingRedirectToBlockId,
  isQuestionLogicValid,
  getQuestionLogicRedirectBlockId,
  isSurveyFullWidth,
  isLandingCurrentSection,
  getSurveySectionLastPageNumber,
  hasSurveyQuestionsSectionOnlyOnePage,
  isCurrentSectionHeaderContentEnabled,
  getCurrentSectionHeaderLogoImageLinkUrl,
  getCurrentSectionHeaderLogoImageSizePreset,
  getCurrentSectionHeaderLogoImageSize,
  getCurrentSectionHeaderLayout,
  getCurrentSectionHeaderTextContent,
  getCurrentSectionHeaderClientUuid,
  isSurveyFirstPage,
  getDisplayPage,
  getLatestVisitedPageNumber,
  getVisitedPages,
  getVisitedPagesLength,
  isSurveyBackButtonEnabled,
};

export const isLastPage = state => {
  // incrementing max page to make available preview empty TP @sinslav
  const emptyEndPageOffset = isEndEmpty(state) ? 1 : 0;
  const lastPage = Math.max(getLastPageNumber(state) + emptyEndPageOffset, 0);
  // decrementing last page if TP is turned off @sinslav
  const turnedOffOffset = !isEndEnabled(state) ? 1 : 0;
  return getCurrentPage(state) === lastPage - turnedOffOffset;
};

export const shouldSurveyPreviewRenderPoweredBy = state => isLastPage(state);

export default combineReducers({
  survey: surveyTakerReducer,
  response: responseReducer,
  form: formReducer, // @TODO use form reducer at root level, remove at this level @sinslav
});
